// extracted by mini-css-extract-plugin
export default {"itemWrapper":"ItemWrapper_itemWrapper__JW4VN"};